module.exports = __webpack_public_path__ + "pranje.9a3e4981eddd4f75bd1f.jpg";